import FormJaivana from 'dashboard_jaivana_v1';

/**
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */

class CustomAlistamiento extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                   = this.initForm.bind(this);
        this.successTablaItemFichas     = this.successTablaItemFichas.bind(this);
        this.uploadTable                = this.uploadTable.bind(this);
        this.tamanoDatos                = 0;
        this.grabarTodo                 = this.grabarTodo.bind(this);
        this.successGrabarItem          = this.successGrabarItem.bind(this);
        this.loteChange                 = this.loteChange.bind(this);
        this.formato                    = this.formato.bind(this);
        this.formato2                   = this.formato2.bind(this);
        this.successSearch              = this.successSearch.bind(this);
        this.aprobacionCancelacion      = this.aprobacionCancelacion.bind(this);
        this.observacion                = '';
        this.etapa_id                   = 0;
        this.lote                       = '';
        this.abastecimiento             = '';
        //this.gridOptionsAlistamietnto   = Object.assign({},this.gridOptions);
        this.successTraerDatosFicha     = this.successTraerDatosFicha.bind(this);
        //this.onSelectionChangedNada     = this.onSelectionChangedNada(this);
        this.archivoPDF                 = this.archivoPDF.bind(this);
        this.successArchivoPDF          = this.successArchivoPDF.bind(this);
        this.archivoPDFEmpaque                  = this.archivoPDFEmpaque.bind(this);
        this.successArchivoPDFEmpaque           = this.successArchivoPDFEmpaque.bind(this);
        this.successTablaMaterialEmp = this.successTablaMaterialEmp.bind(this);
        this.gridOptionsMatEmp = Object.assign({}, this.gridOptions);
        this.retornarDatosFicha         =       this.retornarDatosFicha.bind(this);
        this.retornarAlistamientoId     =       this.retornarAlistamientoId.bind(this);
        this.retornarMaterialEmpaque    =       this.retornarMaterialEmpaque.bind(this);
        this.detalleMateriaPrima = "Materia prima";
        this.detalleMaterialEmpaque = "Material empaque";

        this.tamMateriaPrima = 0;
        this.tamMaterialEmpaque = 0;
        this.verFormula = this.verFormula.bind(this);
        this.successVerFormula = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula = Object.assign({}, this.gridOptions);
        this.setLote                    = this.setLote.bind(this);
    }

    initForm(){
        console.log('CustomAlistamiento, @version: 1.01.0054, @author:Sebastian Noreña Márquez, @updated: Sebastian Rios E.');
        this.retornarDatosFicha();
        this.retornarAlistamientoId();
        this.retornarMaterialEmpaque();
        this.getField('btnAgregar').setClick(this.grabarItem);
        this.getField('btnGrabar').setClick(this.grabarTodo);
        this.getField('btnCancelacion').setClick(this.aprobacionCancelacion)
        this.getField('es_envasado').setOnChange(this.successSearch);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.data;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    retornarDatosFicha(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTraerDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        // produccion_fichas-iddatos
        /*this.generalFormat.nombre_accion = 'servicio_produccion_alistamiento_buscar_datos_fichas_por_id'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successTraerDatosFicha,
                error: this.error_,
                general: this.generalFormat
            });*/
    }
    retornarAlistamientoId(){

        let datos = {
            datos:{
                value: this.props.data.id_ficha,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-alistamiento', operacion: 'porabastecer', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });

        // alistamiento-porabastecer
        /*this.generalFormat.nombre_accion = 'servicio_produccion_alistamiento_fichas_leid_abastecer_por_id'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: bodys,
                success: this.successTablaItemFichas,
                error: this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/
    }
    retornarMaterialEmpaque(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'fichaid', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaMaterialEmp,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successTablaItemFichas(data){
        //console.log("successTablaItemsFichas",data);
        if(data.estado_p === 200){
            this.gridOptions['rowData'] = [];
            this.getField('tablaAlistamiento').initData(this.gridOptions);
            let configCell = new Map();
            this.tamMateriaPrima = data.data.length;
            this.tamanoDatos = data.data.length;   
            configCell.set('lote',{cellRenderer:this.setLote,singleClickEdit: true,cellStyle: {backgroundColor: "rgb(238,238,238)",borderRadius:"5px" },onCellValueChanged:this.loteChange,width: 150,editable: true,field: 'lote'});
            configCell.set('cantidad_galones',{cellRenderer:this.formato2,  cellStyle: { textAlign: "right" },field: 'cantidad_galones' });
            configCell.set('nombre_unidad',{cellStyle: { textAlign: "right" },field: 'nombre_unidad' });
            configCell.set('cantidad_kilos',{cellRenderer:this.formato,  cellStyle: { textAlign: "right" },field: 'cantidad_kilos' });
            this.gridOptions['rowData'] = data.data;
            this.getField('tablaAlistamiento').initData(this.gridOptions,configCell);
            this.archivoPDF();
        }else{
            this.getField('tablaAlistamiento').toggle(false);
            this.tamanoDatos = 0;
        }
    }


    successTablaMaterialEmp(data){
        //console.log("successTablaMaterialEmp",data);
        if(data.estado_p === 200){
            this.tamMaterialEmpaque = data.data.length;
            this.getField('tablaMaterialEmpaque').toggle(true);
            let configCell = new Map();
            this.gridOptionsMatEmp['rowData'] = data.data;
            this.getField('tablaMaterialEmpaque').initData(this.gridOptionsMatEmp,configCell);
            this.archivoPDFEmpaque();
        }else{
            this.getField('tablaMaterialEmpaque').toggle(false);
        }
    }

    archivoPDF(){
        let datos = {
            datos:{
                value: this.props.data.actividad_id,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                detalle: this.detalleMateriaPrima // "Materia prima"
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'urlalistamiento', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successArchivoPDF,
            error: this.error_,
            general: this.generalFormatPmv
        });
        //produccion_fichas-urlalistamiento
        /*
        this.generalFormat.nombre_accion = '2-produccion_fichas-urlalistamiento'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: bodys,
                success: this.successArchivoPDF,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successArchivoPDF(data){
        //console.log("successArchivoPdf---",data.data);
        if(data.estado_p === 200){
            let tamMatPri = data.data.length;

            this.getField('detalle_empaque').setValue('Material empaque');
            let urlArrary = [];
            let url = [];
            for (let i = 0; i < tamMatPri; i++){
                let codigo_bodega = data.data[i].codigo_bodega;
                url.push(data.data[i].url_alistamiento);
                let text = 'PDF Materia prima, bodega ';
                //console.log("array--",codigo_bodega);

                urlArrary.push("<li><a href='" + url[i] + "' target='_blank'>" + text + codigo_bodega + "</a></li>");
            }
            let etiqueta = "<ul>" + urlArrary + "</ul>"

            this.getField("archivo").setValue(etiqueta);

            //let url = data.data[0].url_alistamiento;
            //let etiquetaHTML = "<a href='" + url + "' target='_blank'>" + text + codigo_bodega + "</a>";
            //this.getField('archivo').setValue(etiquetaHTML);

        }
    }
    archivoPDFEmpaque(){
        let datos = {
            datos:{
                value: this.props.data.actividad_id,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                detalle: this.detalleMaterialEmpaque//this.getField('detalle_empaque').getValue(),
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'urlalistamiento', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successArchivoPDFEmpaque,
            error: this.error_,
            general: this.generalFormatPmv
        });
       // produccion_fichas-urlalistamiento
        /*this.generalFormat.nombre_accion = '2-produccion_fichas-urlalistamiento'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: bodys,
                success: this.successArchivoPDFEmpaque,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successArchivoPDFEmpaque(data){
        //console.log('successArchivoPDFEmpaqueurls',data);
        if(data.estado_p === 200){
            let tamMatEmp = data.data.length;
            let urlArrary = [];
            let url = [];
            for (let i = 0; i < tamMatEmp; i++){
                let codigo_bodega = data.data[i].codigo_bodega;
                url.push(data.data[i].url_alistamiento);
                let text = 'PDF Material empaque, bodega ';
                //console.log("array--",codigo_bodega);

                urlArrary.push("<li><a href='" + url[i] + "' target='_blank'>" + text + codigo_bodega + "</a></li>");
            }
            let etiqueta = "<ul>" + urlArrary + "</ul>"
            this.getField("archivo_empaque").setValue(etiqueta);

            //let etiquetaHTML = "<a href='" + url + "' target='_blank'>" + text + codigo_bodega + "</a>";
            //let url = data.data[0].url_alistamiento;
            //this.getField('archivo_empaque').setValue(etiquetaHTML);            
            //console.log("urls",url);
        }
    }
    
    successTraerDatosFicha(data){
        let datosFicha = [];
        if(data.estado_p === 200){
            this.getField('lista_items_leidos').setVisible(true);
            datosFicha.push(data.data[0]);
            this.getField('lista_items_leidos').setItemsFichas(datosFicha);
        }else{
            this.getField('lista_items_leidos').setVisible(false);
        }

    }

    aprobacionCancelacion(props){
        //this.getField('btnCancelacion').setDisabled(true)
        let datos = {
            datos:{
                produccion_fichas_id: this.props.data.id_ficha,
                proceso_id: this.props.data.proceso_id, //this.procesos_id
                actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                actividad_id: this.props.data.actividad_id,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-alistamiento', operacion: 'cancelar', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successCloseEstage,
            error: this.error_,
            general: this.generalFormatPmv
        });
        // alistamiento-cancelar
        /*this.generalFormat.nombre_accion = 'servicio_produccion_alistamiento_cancelar_ficha'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: body,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormat
            });*/
       //this.service.send(this.getConstant().formSave(), 'POST', data  ,this.successCloseEstage,this.error_);
    }

    successSearch(){
        if(this.getField('es_envasado').getValue() === 'SI')
            this.getField('lote').setValue(999999);
        else 
            this.getField('lote').setValue('');
    }

    formato(props){
        return ("".formatoPrecio(props.data.cantidad_kilos));
    }

    formato2(props){
        return ("".formatoPrecio(props.data.cantidad_galones));
    }

    setLote(){
        let valor_actual = "ABASTECER";
        let div = document.createElement('div');
        div.textContent = valor_actual;
        div.setAttribute('class','divStyleAlistamiento');
        return this.createElementJaivana(div);
    }

    loteChange(props){
        if(props.newValue !== ""){

            let datos = {
                datos:{
                    produccion_fichas_id: this.props.data.id_ficha,
                    articulo_id: props.data.articulo_id,
                    cantidad: props.data.cantidad_galones,
                    unidad_id: props.data.unidad_id,
                    produccion_fichas_items_id: props.data.id,
                    lote:props.newValue, 
                    actividad_id : this.props.data.actividad_id// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-alistamiento', operacion: 'crear', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGrabarItem,
                error: this.error_,
                general: this.generalFormatPmv
            });
            //alistamiento-crear
            /*this.generalFormat.nombre_accion = 'servicio_produccion_alistamiento_crear_ficha_item_leido'; //ojo!este no recibe parametros nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send( 
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successGrabarItem,
                    error: this.error_,
                    general: this.generalFormat
                });*/
           //this.service.send(this.getConstant().formSave(), 'POST', data  ,this.successGrabarItem,this.error_);
        }
    }
    
    uploadTable(){ 
        let datos = {
            datos:{
                value: this.props.data.id_ficha,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-alistamiento', operacion: 'porabastecer', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successTablaItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });
        // alistamiento-porabastecer
        /*this.generalFormat.nombre_accion = 'servicio_produccion_alistamiento_fichas_leid_abastecer_por_id'; //ojo!este no recibe parametros nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successTablaItemFichas,
                error: this.error_,
                general: this.generalFormat,
                showMessage :false
            });*/
       //this.service.send(this.getConstant().searchFormat().format(this.props.data.id_ficha,"tablaAlistamiento",'servicio',this.formId), 'GET', undefined ,this.successTablaItemFichas,this.error_);
    }

    grabarTodo(props){

        let datos = {
            datos:{
                produccion_fichas_id: this.props.data.id_ficha,
                proceso_id: this.props.data.proceso_id,
                actividad_configuracion_id: this.props.data.actividad_configuracion_id,
                actividad_id: this.props.data.actividad_id,// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }
        this.getField('btnGrabar').setDisabled(true);
        this.generalFormatPmv = { tipo_servicio: 'prod-alistamiento', operacion: 'grabar', operacion_tipo: 'consultar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successCloseEstage,
            error: this.error_,
            general: this.generalFormatPmv
        });
        // alistamiento-grabar
        /*this.generalFormat.nombre_accion = 'servicio_guardar_alistamiento'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send( 
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: body,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormat
            });*/
       //this.service.send(this.getConstant().formSave(), 'POST', data  ,this.successCloseEstage,this.error_);
    }

    successGrabarItem(data){
        if(data.estado_p === 200)
            if(this.tamanoDatos > 1)
                this.uploadTable();
            else
                this.getField('tablaAlistamiento').toggle(false);  
    }

}


FormJaivana.addController("prod-alistamiento",CustomAlistamiento);

export default CustomAlistamiento;